import React, { Component } from "react";
import ReactModal from "react-modal";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";

type Props = {
    showModal: boolean;
};

type State = {
    modalIsOpen: boolean;
};

class OfflineModeNotReadyModal extends Component<Props, State> {
    readonly state: State = {
        modalIsOpen: this.props.showModal,
    };

    afterOpenModal = () => {};

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
        });
    };

    render() {
        const modalStyle = {};

        return (
            <div className="OfflineModeNotReadyModal">
                <ReactModal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Example Modal"
                    style={modalStyle}
                    className={"modalClass"}
                    overlayClassName={"overlayClass"}
                    ariaHideApp={true}>
                    <div className="">
                        <div className={"d-flex w-100 justify-content-end"}>
                            {/*<OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />*/}
                        </div>
                        <div>
                            <OwTitle leftIconName={"fad fa-wifi-slash"} title={"offline_mode_not_ready"} tag={"h5"} className={"mb-2"} />
                            <p className={"text-muted"}>
                                <OwTranslate defaultMessage={"offline_mode_isnt_ready_blurb"} id={"offline_mode_isnt_ready_blurb"} />
                            </p>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

export default OfflineModeNotReadyModal;
